import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import BgSpa from "../../images/hotelSpaBg.png";
import BackButton from "../bars/BackButton";
import Skeleton from "../../components/skeletons/skeleton";
import { convert_24_to_12 } from "../../utils/util";
import NotActive from "../../components/alert/NotActive";
import { SpaPageView } from "../../utils/Analytics";

function Spa() {
  const location = useLocation();
  const [spaData, SetSpaData] = useState([]);
  const [hotelData, SethotelData] = useState([]);
  const [closedSpa, setclosedSpa] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  const [spaHide, SetspaHide] = useState(true);
  const currentUrl = window.location.href;
  const urlArray = currentUrl.split("/");
  const hotelId = urlArray[urlArray.length - 1];
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const getSpa = async () => {
    setLoading(true);
    try {
      await axios({
        method: "post",
        url: `${baseURL}/api/spasV2`,

        data: {
          hotelId: hotelId,
        },

        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        SetSpaData(response.data.data);

        setLoading(false);

        // if (response.data.data.length == 0) {
        //     // console.log("hii");
        //     setAvailable(true);
        // }
        // SethotelData(response.data.data);
      });
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(hotelId);
    // if (localStorage.getItem("phone_no") == null) {
    //     navigate("../");
    // }

    getSpa();
  }, []);

  useEffect(() => {
    if (spaData.length === 1) {
      navigate(
        `/spa-catagory/${hotelId}-${spaData[0].id}`, 
        { state: { spaLength:1 } } 
      );
      // console.log(`/spa-catagory/${hotelId}-${spaData[0].id}`);
    }
  }, [spaData]);

   useEffect(() => {
      SpaPageView();
     }, []);
  
console.log("back");
  return (
    <div>
    {!loading ? ( <div className="mb-28 relative">
        <div className="absolute top-3 left-3">
          <BackButton whiteTheme={true}  />
        </div>
        <img
          className="w-screen sm:h-[230px] h-[117px]"
          src={BgSpa}
          alt="bgHotelguide"
        />
        <div className="section-wrap mx-4 mt-6 sm:mt-14">
          <div className="guestName sm:text-center text-left">Spa</div>
          <div>
            <div className="gridTab grid grid-flow-row grid-cols-1 gap-3 gap-x-4 lg:mt-6 mt-3">
              {spaHide
                ? spaData.map((spaData, index) => 
                     spaData.is_open == 1 ? (
                      <Link
                        to={"../spa-catagory/" + hotelId + "-" + spaData.id}
                        state={spaData}
                        key={index}
                        className="flex flex-row sm:flex-col items-center p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
                      >
                      {spaDetails(spaData)}
                      </Link> 
                      )  : (
                      <div
                      key={index}
                      onClick={() => {
                        setclosedSpa(spaData?.name);
                        setShowAlert(true);
                      }}
                      type="button"
                      className="flex flex-row sm:flex-col items-center p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all cursor-pointer"
                    >
                    {spaDetails(spaData)}
                    </div> )
                )
              : null}
               {showAlert && (<NotActive Name={closedSpa} title={'spa'} hideModal={() => setShowAlert(false)}/>) }
            </div>
          </div>
        </div>
      </div> ):
      (<Skeleton type="page"/> )}
    </div>
  );
}

export default Spa;


function spaDetails(spaData){

    return (
      <>
      <div className="sm:w-full flex bg-gray-200 rounded-md overflow-hidden sm:h-[160px] w-[56px] h-[56px] ">
        <img
          width="100%"
          height="100%"
          className={`flex items-stretch bg-contain object-cover transition w-full sm:h-full ${
            spaData?.is_open == 1 ? "" : "filter grayscale" }`}
          src={spaData?.image}
          alt="hotelGuide"
        ></img>
      </div>
      <div className="flex-col pl-[10px] w-full sm:pl-0">
        <div className="sm:mt-2 mt-0 sm:text-base text-[14px] font-medium">
          {spaData?.name}
        </div>
        {(spaData?.startTime && spaData?.closeTime) ?  <div className="mt-1 sm:text-xs text-[11px] text-[#9A9A9A] font-medium mb-1">
          Working Hours - {convert_24_to_12(spaData?.startTime ? spaData?.startTime : '' )} to {convert_24_to_12(spaData?.closeTime ? spaData?.closeTime : '' )}
        </div>  :""}
      {/* {spaData?.startTime != spaData?.closeTime ?  <div className="mt-1 sm:text-xs text-[11px] text-[#9A9A9A] font-medium mb-1">
          Working Hours - {convert_24_to_12(spaData?.startTime ? spaData?.startTime : '' )} to {convert_24_to_12(spaData?.closeTime ? spaData?.closeTime : '' )}
        </div>
        :
        <div className="mt-1 sm:text-xs text-[11px] text-[#9A9A9A] font-medium mb-1">
          Working Hours -  24x7
        </div>} */}
      </div>
      </>
    )
}
